import type { ChildAvailabilitySearchResults } from '@sola/schema/dotcom/children/child.ts';
import { ChildAvailabilitySearchResultsSchema } from '@sola/schema/lib/skippy.ts';

/** Create a stable fingerprint from a plain object for use as a storage-key namespace. */
export const buildStorageFingerprint = (
  obj: Record<string, unknown>,
): string => {
  const key = JSON.stringify(obj, Object.keys(obj).toSorted());
  return btoa(key).replaceAll(/[+/=]/g, '');
};

export const createSessionStorage = () => {
  return {
    get: (name: string) => {
      return sessionStorage.getItem(name);
    },
    set: (name: string | string[], item: string | string[]): void => {
      if (typeof name === 'string' && typeof item === 'string') {
        sessionStorage.setItem(name, item);
      } else if (
        Array.isArray(name) &&
        Array.isArray(item) &&
        name.length === item.length
      ) {
        for (const [index, e] of name.entries()) {
          sessionStorage.setItem(e, item[index]);
        }
      }
    },
    compare: (names: string[], items: string[]) => {
      if (names.length !== items.length) {
        return false;
      }
      for (const [i, key] of names.entries()) {
        if (sessionStorage.getItem(key) !== items[i]) {
          return false;
        }
      }
      return true;
    },
    remove: (name: string) => {
      sessionStorage.removeItem(name);
    },
    readChildStore: (
      key = 'sacChildren',
    ): ChildAvailabilitySearchResults | undefined => {
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) {
          return undefined;
        }
        const parsed = ChildAvailabilitySearchResultsSchema.safeParse(
          JSON.parse(raw),
        );

        if (parsed.success) {
          return parsed.data as unknown as ChildAvailabilitySearchResults;
        }
        return undefined;
      } catch {
        // Malformed JSON or other error - treat as cache miss
        return undefined;
      }
    },
  };
};
